import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useState, useEffect } from 'react';
import CustomStepper from '../components/CustomStepper';
import WhatsappFloater from '../components/WhatsappFloater';

const OnBoardingOutletPage = () => {
  const location = useLocation();
  const [title, setTitle] = useState('');
  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  useEffect(() => {
    const url = location.pathname;
    let newTitle = '';
    let step = 0;

    if (url.includes('create-business')) {
      newTitle = '1. Crear nueva productora';
      step = 0;
    } else if (url.includes('create-event')) {
      newTitle = '2. Crear evento';
      step = 1;
    } else if (url.includes('create-ticket')) {
      newTitle = '3. Crear entrada';
      step = 2;
    }

    setTitle(newTitle);
    setCurrentStepIndex(step);
  }, [location.pathname]);

  return (
    <div className="flex flex-col gap-8 my-6 md:px-10 lg:px-20">
      <WhatsappFloater />
      <CustomStepper steps={['Crear productora', 'Crear evento', 'Crear entrada']} currentStep={currentStepIndex} />
      <h1 className="text-2xl font-medium">{title}</h1>
      <AnimatePresence mode="wait">
        <Outlet key={location.pathname} />
      </AnimatePresence>
    </div>
  );
};

export default OnBoardingOutletPage;
